module.exports = __webpack_public_path__ + "img/image-7.fe971392.svg";